import svg from 'src/assets/pin-powered-down.svg?raw';
import { COLOR_VALUES } from 'src/services/constants';
import SvgMarker from './SvgMarker';

export default class PoweredDownSvgMarker extends SvgMarker {
  constructor() {
    super(svg, {
      height: 91,
      width: 60,
      innerColor: COLOR_VALUES.WHITE,
      outerColor: COLOR_VALUES.DARK,
    });
  }
}
